import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './HomePage.css';

export const HomePage: React.FC = () => {
  const { logout } = useAuth();

  return (
    <div className="home-page">
      <button className="logout-btn-corner" onClick={logout}>
        تسجيل خروج
      </button>
      <img 
        className="screenshot"
        src="/Screenshot 2025-10-08 165008.png"
        alt="Sanad Website" 
      />
    </div>
  );
};
